import { createSlice } from '@reduxjs/toolkit';
import { getEngagementRateDataFalse, getQualityVisits, getTopWebsites, getWebMatrixCostDataFalse, getWebMatrixFalse, getWebMatrixGeographyDataFalse, getWebMatrixMultiUsageFalse, getWebMatrixPatientAnalysisSummary, getWebMatrixPatientCount, getWebMatrixPatientFalse, getWebMatrixTrue } from '../thunks/webMatrixThunks';
import { generateDistinctHexColors, convertFullMonthNamesToShort, sortDataByMonth,
    createDistrictUSAMapData,  
    getOverallPhysicians, 
    handlePeriodChange, 
    makeBarDataSeries, 
    makeLabels,
    removeEmptyNestedKeys,
    makeSeriesForDonutChart,
    createStateUSAMapData,
    calculateYmax,
    setTickAmount, 
    processDataForClickEngagement, 
    makephysicianEngagementSegmentsDonutChartData, 
    prepareTopCitySiteChartData, 
    customCategories, 
    convertYYYYMMToShortMonth } from '../../utility';
import { Cost_Per_Quality_Visit_by_Channels_StaticDataBA, Cost_Per_Quality_Visit_by_Channels_StaticDataFR, Cost_Per_Quality_Visit_by_Channels_StaticDataRE, Cost_Per_Quality_Visit_by_Channels_StaticDataREMM, Cost_Per_Quality_Visit_by_Channels_StaticDataRPD, Cost_Per_Quality_Visit_by_Channels_StaticDataTP, Cost_Per_Quality_Visit_by_Channels_StaticDataXE, Cost_Per_Quality_Visit_by_Channels_StaticDataZP, ctr_broken_down_by_creative_type_data,qvr_by_hva_chart_data, qvr_by_hva_chart_data_66 } from '../../constants/webMatrixStaticData';
import { capitalizeKeys, convertPaidSummaryData, createAreaChartSeries, createChartData, createChartDataForRepeatEngagement, createCityData, createSameKeyData, createUsersAreaChartSeries, DonutChartData, dtcProcessDataForClickEngagement, makepaidMediaSummaryBarData, makeQualityVisitBarData, transformDataForStackedBar, transformIntoCostData, transformRepeatEngagement, transformSessionDurationData } from '../../utility/webMatrixUtility';


const webMatrixInitialState = {
    isLoading: false,
    isGeographyLoading: false,
    isMultiUsageLoading: false,
    error: null,
    webMatrixData: {},
    webMatrixDataTrue: {},
    average_bounce_rate: 0,
    average_qvr: 0,
    sum_quality_visits: 0,
    sum_sessions: 0,
    sessions: {
        xAxisCategories: [],
        dataSets: []
    },
    quality_visits: {
        xAxisCategories: [],
        dataSets: []
    },
    qvr: {
        xAxisCategories: [],
        dataSets: []
    },
    bounce_rate: {
        xAxisCategories: [],
        dataSets: []
    },
    visits_broken_down_by_channels: {
        xAxisCategories: [],
        dataSets: []
    },
    quality_visits_broken_down_by_channels: {
        xAxisCategories: [],
        dataSets: []
    },
    visits_broken_down_by_creative_type: {
        xAxisCategories: [],
        dataSets: []
    },
    cost_per_quality_visit_by_channels: {
        xAxisCategories: [],
        dataSets: []
    },
    cost_per_quality_visit_by_channels_staticFR: { //need to delete this whole object
        xAxisCategories: [],
        dataSets: []
    },
    cost_per_quality_visit_by_channels_staticRE: { //need to delete this whole object
        xAxisCategories: [],
        dataSets: []
    },
    cost_per_quality_visit_by_channels_staticBA: { //need to delete this whole object
        xAxisCategories: [],
        dataSets: []
    },
    cost_per_quality_visit_by_channels_staticTP: { //need to delete this whole object
        xAxisCategories: [],
        dataSets: []
    },
    cost_per_quality_visit_by_channels_staticXE: { //need to delete this whole object
        xAxisCategories: [],
        dataSets: []
    },
    cost_per_quality_visit_by_channels_staticREMM: { //need to delete this whole object
        xAxisCategories: [],
        dataSets: []
    },
    cost_per_quality_visit_by_channels_staticZP: { //need to delete this whole object
        xAxisCategories: [],
        dataSets: []
    },
    cost_Per_Quality_Visit_by_Channels_StaticDataRPD: { //need to delete this whole object
        xAxisCategories: [],
        dataSets: []
    },
    ctr_broken_down_by_creative_type: {
        xAxisCategories: [],
        dataSets: []
    },
    qvr_by_hva_chart: {
        xAxisCategories: [],
        dataSets: []
    },
    qvr_by_hva_chart_66: { // need to remove
        xAxisCategories: [],
        dataSets: []
    },
    audience_segement_by_hva: {
        xAxisCategories: [],
        dataSets: []
    },
    sessionsQualityVisits: { chartSeries: [] },
    dtcData: {
        isWebMatrixPatientLoading: false,
        isTopWebsitesLoading: false,
        isSummaryLoading: false,
        isEngagementRateLoading: false,
        ageEngagementData: [],
        genderEngagementData: [],
        deviceEngagementData: [],
        geographicalData: [],
        topWebsitesData: [],
        physicianEngagementSegmentsDonutChartData: [],
        // npi table fields start
        isWebMatrixPatientSummaryLoading: false,
        dtcTableData: [],
        filteredDtcTableData: [],
        currentPage: 1,
        pageSize: 20,
        totalRecordsFetch: 0,
        totalPages: 0,
        // npi table fields end
        cityOverallPhysicians: 0, 
        stateOverallPhysicians: 0,
        cityDistributionRegion: [], 
        cityMapSeries: [], 
        stateDistributionRegion: [],
        stateBreakdownUSAMapData: [],
        stateMapSeries: [],
        regionalEngagement: [],
        stateEngagement: [],
        clickEngagement: {
            labels: [],
            series: [],
            categoriesForAll: [],
            categories: [],
            actualData: {},
            selectedChannel: 'All',
            colors: [],
            yMax: 10,
            tickAmount: 5
        },
        quality_visits_for_engagement: { 
            currentEngagement: 0,
            previousEngagement: 0,
            qualityVisitChart: {
                barData: [{
                    name: '',
                    data: []
                }],
                categories: []
            }
        },
        paidMediaSummary: {
            totalPaidMediaSummary: 0,
            currentEngagement: 0,
            previousEngagement: 0,
            paidMediaBarData: {
                barData: [{
                    name: '',
                    data: []
                }],
                categories: []
            },
            isPeriodChangeIncrease: false,
            periodChange: 0
        },
        paidSearchSummary: {
            totalPaidSearchSummary: 0,
            currentEngagement: 0,
            previousEngagement: 0,
            paidSearchBarData: {
                barData: [{
                    name: '',
                    data: []
                }],
                categories: []
            }
        },
        costBarChart: {
            categories: [],
            data: []
        },
        conversionRateBarChart: {
            categories: [],
            data: []
        },
        ctrData: [{
            name: '',
            data: []
        }],
        totalImpressions: 0,
        totalClick: 0,
        totalCTR: 0,
        totalConversion: 0,
        totalCostPerConversion: 0,
        totalCost: 0,
        topCitiesChartData: {
            series: [],
            categories: []
        },
        topSitesChartData: {
            series: [],
            categories: []
        },
        trigger_engagement: []
    },
    isCostApiLoading: false,
    sum_of_events: 0,
    avg_of_event_per_session: 0,
    avg_session_duration: 0,
    sum_of_returning_user: 0,
    sum_of_new_users: 0,
    sum_of_page_views: 0,
    cost_per_30_seconds: [],
    totalPaidMediaCPC: 0,
    totalPaidSearchCPC: 0,
    totalEngagedSession: 0,
    paidSearchCostData: [],
    paidMediaCostData: {
        categories: [],
        dataSets: []
    },
    avg_session_duration_data: {
        xAxisCategories: [],
        dataSets: []
    },
    returning_user_data: {
        xAxisCategories: [],
        dataSets: []
    },
    new_users_data: {
        xAxisCategories: [],
        dataSets: []
    },
    users_series_data: [],
    page_views_data: {
        xAxisCategories: [],
        dataSets: []
    },
    overallMapCount: 0,
    stateBreakdownUSAMapData: [],
    stateMapBarSeries: [],
    engagedSessionData: {
        xAxisCategories: [],
        dataSets: []
    },
    session_duration_by_time: {
        xAxisCategories: [],
        dataSets: []
    },
    repeat_engagement_distribution: {
        xAxisCategories: [],
        dataSets: []
    }
};

const webMatrix = createSlice({
    name: 'webMatrix',
    initialState: webMatrixInitialState,
    reducers: {
        resetToInitialState(state, action) {
            const preservedPaidMediaSummary = state.dtcData.paidMediaSummary;
            const preservedPaidSearchSummary = state.dtcData.paidSearchSummary;
            Object.keys(webMatrixInitialState).forEach(key => {
                if (key !== 'dtcData') {
                    state[key] = webMatrixInitialState[key];
                }
            });
            state.dtcData = {
                ...webMatrixInitialState.dtcData,
                paidMediaSummary: preservedPaidMediaSummary,
                paidSearchSummary: preservedPaidSearchSummary
            };
        },
        resetTableStates(state, action) {
            return {
                ...state,
                dtcData: {
                    ...state.dtcData,
                    isWebMatrixPatientSummaryLoading: false,
                    dtcTableData: [],
                    filteredDtcTableData: [],
                    pageSize: 20,
                    totalRecordsFetch: 0,
                    totalPages: 0
                }
            };
        },                
        setDigitalPhysicianEngagementChannel: (state, action) => {
            state.dtcData.clickEngagement.selectedChannel = action?.payload;
        },
        setDigitalPhysicianEngagementData: (state, action) => {
            const processedData = dtcProcessDataForClickEngagement(action.payload, state?.dtcData?.clickEngagement?.actualData);
            state.dtcData.clickEngagement.series = processedData;
            state.dtcData.clickEngagement.yMax = calculateYmax(processedData,state.dtcData.clickEngagement.selectedChannel);
        },
        setCurrentPage: (state, action) => {
            state.dtcData.currentPage = action.payload;
        },
        handleSearch: (state, action) => {
            const { searchTerm } = action.payload;
            const updatedProviders = state.dtcData.dtcTableData.map(provider => ({
                ...provider,
                patient_audience_type: Array.isArray(provider.patient_audience_type)
                    ? provider.patient_audience_type.join(', ')
                    : provider.patient_audience_type,
                channel: Array.isArray(provider.channel)
                    ? provider.channel.join(', ')
                    : provider.channel,
                vendor: Array.isArray(provider.vendor)
                    ? provider.vendor.join(', ')
                    : provider.vendor
            }));
            const filteredProviders = updatedProviders.filter(provider => {
                const providerData = Object.values(provider)
                    .map(value => typeof value === 'string' ? value.trim().toLowerCase() : value)
                    .join(' ');
                const trimmedSearchTerm = searchTerm?.trim()?.toLowerCase();
                return providerData.includes(trimmedSearchTerm);
            });
            state.dtcData.filteredDtcTableData = filteredProviders;
            state.dtcData.totalRecordsFetch = filteredProviders.length;
            state.dtcData.totalPages = Math.ceil(filteredProviders.length / (state.dtcData.pageSize || 1));
            state.dtcData.currentPage = 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWebMatrixFalse.fulfilled, (state, action) => {
                state.error = null;
                state.isLoading = false;
                state.webMatrixData = action.payload;
                // tiles states
                state.average_bounce_rate = action?.payload?.average_bounce_rate;
                state.average_qvr = action?.payload?.average_qvr;
                state.sum_quality_visits = action?.payload?.sum_quality_visits;
                state.sum_sessions = action?.payload?.sum_sessions;
                state.avg_of_event_per_session = action?.payload?.avg_events_per_session || 0;
                state.avg_session_duration=action?.payload?.avg_session_duration;                
                state.sum_of_events = action?.payload?.sum_event_counts;
                state.sum_of_new_users = action?.payload?.sum_new_users;
                state.sum_of_page_views = action?.payload?.sum_page_views;
                state.sum_of_returning_user = action?.payload?.sum_returning_users;

                //charts states
                state.sessions = createChartData(sortDataByMonth(action.payload?.sessions_chart_data), 'sessions_value', true,true);
                state.quality_visits = createChartData(sortDataByMonth(action.payload?.quality_visits_chart_data), 'quality_visits_value', true,true);
                state.qvr = createChartData(sortDataByMonth(action.payload?.qvr_bar_chart_data), 'count', true,true);
                state.bounce_rate = createChartData(sortDataByMonth(action.payload?.bounce_rate_bar_chart_data), 'count', true,true);
                state.visits_broken_down_by_channels = createChartData(sortDataByMonth(action.payload?.source_medium_bar_chart_data), 'source_medium_group_data',false, true);
                state.quality_visits_broken_down_by_channels =createChartData(sortDataByMonth(action.payload?.source_quality_bar_chart_date), 'source_medium_group_data',false, true);
                state.visits_broken_down_by_creative_type = createChartData(sortDataByMonth(action.payload?.creative_name_bar_chart_data), 'creative_name_data',false, true);
                state.cost_per_quality_visit_by_channels_staticFR = createChartData(Cost_Per_Quality_Visit_by_Channels_StaticDataFR, 'source_medium_group_data',false, true); // need to delete this
                state.cost_per_quality_visit_by_channels_staticRE = createChartData(Cost_Per_Quality_Visit_by_Channels_StaticDataRE, 'source_medium_group_data',false, true); // need to delete this
                state.cost_per_quality_visit_by_channels_staticBA = createChartData(Cost_Per_Quality_Visit_by_Channels_StaticDataBA, 'source_medium_group_data',false, true); // need to delete this
                state.cost_per_quality_visit_by_channels_staticTP = createChartData(Cost_Per_Quality_Visit_by_Channels_StaticDataTP, 'source_medium_group_data',false, true); // need to delete this
                state.cost_per_quality_visit_by_channels_staticXE = createChartData(Cost_Per_Quality_Visit_by_Channels_StaticDataXE, 'source_medium_group_data',false, true); // need to delete this
                state.cost_per_quality_visit_by_channels_staticREMM = createChartData(Cost_Per_Quality_Visit_by_Channels_StaticDataREMM, 'source_medium_group_data',false, true); // need to delete this
                state.cost_per_quality_visit_by_channels_staticZP = createChartData(Cost_Per_Quality_Visit_by_Channels_StaticDataZP, 'source_medium_group_data',false, true); // need to delete this
                state.cost_Per_Quality_Visit_by_Channels_StaticDataRPD = createChartData(Cost_Per_Quality_Visit_by_Channels_StaticDataRPD, 'source_medium_group_data',false, true); // need to delete this
                state.sessionsQualityVisits.chartSeries = createAreaChartSeries(sortDataByMonth(action.payload?.sessions_chart_data), 
                    sortDataByMonth(action.payload?.quality_visits_chart_data));

                // average session duration
                let avgSessionDuration = sortDataByMonth(action.payload?.avg_session_duration_chart_data);
                avgSessionDuration = avgSessionDuration.filter(item=>item.count>0).map(item=>
                    ({ x: convertFullMonthNamesToShort([],item.month),y: item.count }));
                state.avg_session_duration_data = avgSessionDuration;
                // page view 
                let pageView = sortDataByMonth(action.payload?.page_views_chart_data);
                pageView = pageView.filter(item=>item.count>0).map(item=>({ x: convertFullMonthNamesToShort([],item.month),y: item.count }));
                state.page_views_data = pageView;
                // new users vs returning users
                const sortedNewUserData = sortDataByMonth(action.payload?.new_users_chart_data|| []);
                const sortedReturningData =sortDataByMonth(action.payload?.returning_users_chart_data || []);
                const usersAreaData = createUsersAreaChartSeries(sortedNewUserData,sortedReturningData);
                state.users_series_data = usersAreaData;
            })
            .addCase(getWebMatrixFalse.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getWebMatrixFalse.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getWebMatrixTrue.fulfilled, (state, action) => {
                state.error = null;
                state.isLoading = false;
                state.webMatrixDataTrue = action.payload;
            })
            .addCase(getWebMatrixTrue.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getWebMatrixTrue.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getQualityVisits.fulfilled, (state, action) => {
                const qualityVisitData = action.payload.data || [];
                const qualityVisitCurrentData = qualityVisitData?.current?.qualityVisitData?.sort((a, b) => 
                    new Date(a?.month) - new Date(b?.month)) || [];
                state.dtcData.quality_visits_for_engagement.currentEngagement = qualityVisitData?.current?.total || 0;
                state.dtcData.quality_visits_for_engagement.previousEngagement = qualityVisitData?.previous?.total || 0;
                state.dtcData.quality_visits_for_engagement.qualityVisitChart = makeQualityVisitBarData(qualityVisitCurrentData);
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getQualityVisits.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getQualityVisits.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getWebMatrixPatientFalse.fulfilled, (state, action) => {
                const webPatients = action.payload || {};
                if(webPatients?.data && Object.keys(webPatients?.data).length){
                    state.dtcData.deviceEngagementData = DonutChartData(webPatients?.data?.engagement_by_device || [],'device');
                    // click engagement
                    const updatedClickEngagementData = capitalizeKeys(webPatients?.data?.click_engagement || {});
                    const newData = removeEmptyNestedKeys(updatedClickEngagementData|| {});
                    state.dtcData.clickEngagement.actualData = newData;
                    const processedData = dtcProcessDataForClickEngagement(state?.dtcData.clickEngagement?.selectedChannel, newData || {});
                    state.dtcData.clickEngagement.series = processedData;
                    state.dtcData.clickEngagement.yMax = calculateYmax(state.dtcData.clickEngagement.series,
                        state.dtcData.clickEngagement.selectedChannel);
                    state.dtcData.clickEngagement.labels = makeLabels(newData, true, true,false,true);
                    state.dtcData.clickEngagement.categoriesForAll = makeLabels(newData, true, false);
                    state.dtcData.clickEngagement.categories = makeLabels(newData);
                    // physician segement donut chart
                    state.dtcData.physicianEngagementSegmentsDonutChartData = makephysicianEngagementSegmentsDonutChartData(
                        webPatients?.data?.segment_counts || {}, true);
                    // map breakdown
                    const regionalData = webPatients?.data?.regional_engagement || [];
                    const cityData = regionalData?.cityEngagement || [];
                    const stateData = regionalData?.stateEngagement;
                    state.dtcData.cityOverallPhysicians = getOverallPhysicians(cityData || []);
                    state.dtcData.stateOverallPhysicians = getOverallPhysicians(stateData || []);
                    state.dtcData.cityMapSeries = createCityData( cityData|| [] ) ;
                    state.dtcData.stateMapSeries = createStateUSAMapData(stateData || []);
                    state.dtcData.stateDistributionRegion = makeBarDataSeries(stateData,false,true) || [];
                    state.dtcData.cityDistributionRegion = makeBarDataSeries(cityData,false,false,true) || [];
                    //CTR
                    const click_through_rate = webPatients?.data?.paid_media_graphs?.graphs?.click_through_rate ;
                    let sortedData = click_through_rate
                        .map(item => ({
                            x: convertYYYYMMToShortMonth(item.month),
                            y: item.percentage
                        }))
                        .sort((a, b) => new Date(a.x) - new Date(b.x)); 
                    sortedData = Array.from(new Map(sortedData.map(item => [item.x, item])).values());
                    if (sortedData.length === 1) {
                        sortedData.push({ x: sortedData[0].x, y: 0 });
                    }
                    const finalData = [
                        {
                            'name': 'Click Through Rate',
                            'data': sortedData
                        }
                    ];
                    state.dtcData.ctrData = finalData;
                    
                    // cost 
                    const totalSpend = webPatients?.data?.paid_media_graphs?.graphs?.total_spend || [];
                    const sortedSpend = totalSpend.sort((a, b) => new Date(a.month) - new Date(b.month));
                    state.dtcData.costBarChart.categories= sortedSpend.map(item => item.month),
                    state.dtcData.costBarChart.data = sortedSpend.map(item => item.count);
                    const counts = sortedSpend?.map(item => item.count) || [];
                    state.dtcData.totalCost = counts?.reduce((cost, intial)=>cost+intial,0) || 0;
                    //conversion rate
                    const conversionRateData = webPatients?.data?.paid_media_graphs?.graphs?.conversion_rate || [];
                    const sortedconversionRate = conversionRateData?.sort((a, b) => new Date(a.month) - new Date(b.month));
                    state.dtcData.conversionRateBarChart.categories= sortedconversionRate.map(item => item.month),
                    state.dtcData.conversionRateBarChart.data = sortedconversionRate.map(item => item.percentage);
                    //tiles data
                    const tilesData = webPatients?.data?.paid_media_graphs?.top_tiles || {};
                    state.dtcData.totalImpressions = tilesData?.impressions || 0;
                    state.dtcData.totalClick = tilesData?.clicks|| 0;
                    state.dtcData.totalCostPerConversion = tilesData?.total_spend.toFixed(2) || 0;
                    const totalConversion_rate = 
                        tilesData?.clicks > 0 && tilesData?.conversions != null ? (tilesData.conversions / tilesData.clicks) * 100 : 0;
                    state.dtcData.totalConversion = totalConversion_rate.toFixed(2) > 100 ? 100 : totalConversion_rate.toFixed(2);
                    state.dtcData.totalCTR = tilesData?.click_through_rate || 0;
                    //top cities and sites data
                    const topCharts = webPatients?.data?.top_charts || {};
                    state.dtcData.topCitiesChartData.series = prepareTopCitySiteChartData(topCharts,'cities').series;
                    state.dtcData.topCitiesChartData.categories = prepareTopCitySiteChartData(topCharts,'cities').categories;
                }
                
                state.error = null; 
                state.dtcData.isWebMatrixPatientLoading = false;
            })
            .addCase(getWebMatrixPatientFalse.pending, (state, action) => {
                state.dtcData.isWebMatrixPatientLoading = true;
                state.error = null;
            })
            .addCase(getWebMatrixPatientFalse.rejected, (state, action) => {
                state.dtcData.isWebMatrixPatientLoading = false;
                state.error = action.payload;
            })
            .addCase(getTopWebsites.fulfilled, (state, action) => {
                const webPatients = action.payload || {};
                const webSiteData = webPatients?.top_websites || [];
                const updatedData = webSiteData.map(item => ({
                    ...item,
                    website: item.website.replace(/(https?:\/\/)?(www\.)?/i, '')
                }));
                state.dtcData.topWebsitesData = updatedData || [];
                state.error = null; 
                state.dtcData.isTopWebsitesLoading = false;
            })
            .addCase(getTopWebsites.pending, (state, action) => {
                state.dtcData.isTopWebsitesLoading = true;
                state.error = null;
            })
            .addCase(getTopWebsites.rejected, (state, action) => {
                state.dtcData.isTopWebsitesLoading = false;
                state.error = action.payload;
            })
            .addCase(getWebMatrixPatientCount.fulfilled, (state, action) => {
                // paid media summary
                const paidMediaData = action.payload?.data?.current_data || [];
                const mergedData = convertPaidSummaryData(paidMediaData);
                const currentPaidMedia = action.payload?.data?.current_count || 0;
                const previousPaidMedia = action.payload?.data?.previous_count || 0;
                state.dtcData.paidMediaSummary.totalPaidMediaSummary= currentPaidMedia;
                state.dtcData.paidMediaSummary.currentEngagement = currentPaidMedia || 0;
                state.dtcData.paidMediaSummary.previousEngagement = previousPaidMedia || 0;
                state.dtcData.paidMediaSummary.paidMediaBarData = makepaidMediaSummaryBarData(mergedData || []);
                const { period, isPeriodChangeIncrease } = handlePeriodChange(currentPaidMedia, previousPaidMedia);
                state.dtcData.paidMediaSummary.periodChange = period;
                state.dtcData.paidMediaSummary.isPeriodChangeIncrease = isPeriodChangeIncrease;
                //paid search
                const paidSearchData = action.payload?.data?.currentPaidData || [];
                const mergedpaidSearchData = convertPaidSummaryData(paidSearchData);
                const paidSearchFinalData = Object.values(mergedpaidSearchData);
                const totalPaidSearch = action.payload?.data?.current_paid_search_count || 0;
                state.dtcData.paidSearchSummary.totalPaidSearchSummary = totalPaidSearch;
                state.dtcData.paidSearchSummary.currentEngagement = totalPaidSearch;
                state.dtcData.paidSearchSummary.previousEngagement = action.payload?.data?.previous_paid_search_count || 0;
                state.dtcData.paidSearchSummary.paidSearchBarData = makepaidMediaSummaryBarData(paidSearchFinalData || []);

                state.error = null; 
                state.dtcData.isSummaryLoading = false;
            })
            .addCase(getWebMatrixPatientCount.pending, (state, action) => {
                state.dtcData.isSummaryLoading = true;
                state.error = null;
            })
            .addCase(getWebMatrixPatientCount.rejected, (state, action) => {
                state.dtcData.isSummaryLoading = false;
                state.error = action.payload;
            })
            .addCase(getWebMatrixPatientAnalysisSummary.fulfilled, (state, action) => {
                const webPatientsTableData = action.payload || {};
                state.dtcData.dtcTableData = webPatientsTableData?.data || [];
                state.dtcData.filteredDtcTableData = webPatientsTableData?.data || [];
                state.dtcData.totalRecordsFetch = webPatientsTableData?.total_count || 0;
                state.dtcData.totalPages = Math.ceil((webPatientsTableData?.total_count ?? 0) / state.dtcData.pageSize);
                state.error = null; 
                state.dtcData.isWebMatrixPatientSummaryLoading = false;
            })
            .addCase(getWebMatrixPatientAnalysisSummary.pending, (state, action) => {
                state.dtcData.isWebMatrixPatientSummaryLoading = true;
                state.error = null;
            })
            .addCase(getWebMatrixPatientAnalysisSummary.rejected, (state, action) => {
                state.dtcData.isWebMatrixPatientSummaryLoading = false;
                state.error = action.payload;
            })
            .addCase(getWebMatrixCostDataFalse.fulfilled, (state, action) => {
                state.isCostApiLoading = false;
                const costData = action?.payload?.data || {};
                // Cost Per Quality Visit by Channels ($) website engagement/matrix
                const channel_quality_visit_data = costData?.channel_quality_visit?.graph || [];
                const channel_quality_visit_chart_data = transformIntoCostData(channel_quality_visit_data);
                state.cost_per_quality_visit_by_channels = createChartData(channel_quality_visit_chart_data, 'source_medium_group_data',false, true,true);
                // Cost Per 30 Second of Session Visit ($) website engagement/matrix
                const cost_per_30_seconds_data = costData?.cost_per_30_seconds?.graph || [];
                state.cost_per_30_seconds = cost_per_30_seconds_data;
                // paid media engagement CPC
                state.totalPaidMediaCPC = costData?.paid_media?.tile > 0 ? costData?.paid_media?.tile?.toFixed(2) : 0;
                const paidMediaCost = transformDataForStackedBar(costData?.paid_media?.graph || []);
                state.paidMediaCostData.categories = paidMediaCost?.categories || [];
                state.paidMediaCostData.dataSets = paidMediaCost?.series || [];
                // paid search engagement CPC
                state.totalPaidSearchCPC = costData?.paid_search?.tile > 0 ? costData?.paid_search?.tile?.toFixed(2) : 0;
                state.paidSearchCostData= costData?.paid_search?.graph || [];
                state.error = null; 
            })
            .addCase(getWebMatrixCostDataFalse.pending, (state, action) => {
                state.isCostApiLoading = true;
                state.error = null;
            })
            .addCase(getWebMatrixCostDataFalse.rejected, (state, action) => {
                state.isCostApiLoading = false;
                state.error = action.payload;
            })
            .addCase(getEngagementRateDataFalse.fulfilled, (state, action) => {
                const engagementRate = action.payload || {};
                if(engagementRate?.data && Object.keys(engagementRate?.data).length){
                    // age and gender engagement
                    state.dtcData.ageEngagementData = DonutChartData(engagementRate?.data?.engagement_by_age || [],'age');
                    state.dtcData.genderEngagementData = DonutChartData(engagementRate?.data?.engagement_by_gender || [],'gender');
                    //top sites data
                    const topCharts = engagementRate?.data || {};
                    state.dtcData.topSitesChartData.series = prepareTopCitySiteChartData(topCharts,'top_sites').series;
                    state.dtcData.topSitesChartData.categories = prepareTopCitySiteChartData(topCharts,'top_sites').categories;
                    // trigger engagement rate
                    state.dtcData.trigger_engagement = engagementRate?.data?.trigger_engagement || [];
                }
                state.error = null; 
                state.dtcData.isEngagementRateLoading = false;
            })
            .addCase(getEngagementRateDataFalse.pending, (state, action) => {
                state.dtcData.isEngagementRateLoading = true;
                state.error = null;
            })
            .addCase(getEngagementRateDataFalse.rejected, (state, action) => {
                state.dtcData.isEngagementRateLoading = false;
                state.error = action.payload;
            })
            .addCase(getWebMatrixGeographyDataFalse.fulfilled, (state, action) => {
                state.isGeographyLoading = false;
                // geography breakdown
                const data = action?.payload?.data || [];
                state.overallMapCount = data?.geo_mapping?.reduce(
                    (accumulator, currentValue) => accumulator + currentValue.count,
                    0
                ) || 0;
                state.stateBreakdownUSAMapData = createStateUSAMapData(data?.geo_mapping || [] ) ;
                state.stateMapBarSeries = makeBarDataSeries(data?.geo_mapping,false,true) || [];
                // CTR Broken Down by Creative Types(%)
                const finalData = createSameKeyData(data?.visit_broken_by_creative_type || []);
                state.ctr_broken_down_by_creative_type = createChartData(finalData, 'source_medium_group_data',false, true);
                // Quality Visits Broken Down by HVA
                state.qvr_by_hva_chart = createChartData(data?.quality_visit_broken_by_hva || [], 'count_data',false, true);
                // audience_segement_by_hwa
                state.audience_segement_by_hva = createChartData(data?.audience_segement_by_hwa, 'source_medium_group_data',false, true);
                state.error = null;
            })
            .addCase(getWebMatrixGeographyDataFalse.pending, (state, action) => {
                state.isGeographyLoading = true;
                state.error = null;
            })
            .addCase(getWebMatrixGeographyDataFalse.rejected, (state, action) => {
                state.isGeographyLoading = false;
                state.error = action.payload;
            })
            .addCase(getWebMatrixMultiUsageFalse.fulfilled, (state, action) => {
                state.isMultiUsageLoading = false;
                const data = action?.payload?.data || [];
                // engaged session
                state.totalEngagedSession = Math.round(data?.engaged_sessions?.tile || 0);
                let engagedSessionData = sortDataByMonth(data?.engaged_sessions?.graph|| []);
                engagedSessionData = engagedSessionData.filter(item=>item.value>0).map(item=>
                    ({ x: convertYYYYMMToShortMonth(item.month),y: item.value }));
                state.engagedSessionData = engagedSessionData;

                // Session Duration by Time 
                const sessionDurationData = transformSessionDurationData(data?.session_duration) || [];
                state.session_duration_by_time = createChartData(sessionDurationData, 'source_medium_group_data',false, true,false,true);

                // Repeat Engagement Distribution
                const repeatDistributionData = transformRepeatEngagement(data?.repeat_engagement);
                state.repeat_engagement_distribution = createChartDataForRepeatEngagement(repeatDistributionData, 'source_medium_group_data',false, true,false,false,true);
                state.error = null;
            })
            .addCase(getWebMatrixMultiUsageFalse.pending, (state, action) => {
                state.isMultiUsageLoading = true;
                state.error = null;
            })
            .addCase(getWebMatrixMultiUsageFalse.rejected, (state, action) => {
                state.isMultiUsageLoading = false;
                state.error = action.payload;
            });
    }
});


export const { actions } = webMatrix;
export default webMatrix.reducer;